<template>
    <div>

        <div style="width: 100%; margin: 0px auto">
            <el-form>
                <el-form-item>
                    <el-upload drag ref="upload" class="upload-demo" :action="dataObj.host" :data="dataObj"
                        :on-preview="handlePreview" :on-success="handleUploadSuccess" multiple :auto-upload="true"
                        :file-list="fileList" :on-remove="handleRemove" :before-upload="beforeUpload" :limit="100">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import util from "@/libs/util";
export default {
    name: 'SingleUpload',
    props: {
        // value: String,
        caseId: Number
    },

    data() {
        return {
            dataObj: {
                policy: '',
                signature: '',
                key: '',
                ossaccessKeyId: '',
                dir: '',
                host: '',
                bucket: ''
                // callback:'',
            },
        }
    },
    computed: {
        fileUrl() {
            return this.value
        },
        fileName() {
            if (this.value != null && this.value !== '') {
                return this.value.substr(this.value.lastIndexOf('/') + 1)
            } else {
                return null
            }
        },
        fileList() {
            if (this.value !== null && this.value !== '' && this.value !== undefined) {
                return [{
                    name: this.fileName,
                    url: this.fileUrl
                }]
            } else {
                let a = []
                return a;
            }

        },
        showFileList: {
            get: function () {
                return this.value !== null && this.value !== '' && this.value !== undefined
            },
            set: function (newValue) {
            }
        },

    },

    created() {
        this.getPostSignature()
    },
    methods: {
        emitInput(val) {
            this.$emit('test', val)
        },
        handleRemove(file, fileList) {
        },
        handlePreview(file) {
        },
        /**
         * 异步获取直传信息
         */
        getPostSignature() {
            new Promise((resolve, reject) => {
                const _self = this
                const token = util.cookies.get("token");
                axios({
                    url: process.env.VUE_APP_API + "/api/tool/oss/getPostSignatureForOssUpload",
                    method: "get",
                    headers: {
                        authorization: "Bearer " + token,
                    },
                }).then((response) => {
                    _self.dataObj.policy = response.data.data.body.policy
                    _self.dataObj.signature = response.data.data.body.signature
                    _self.dataObj.ossaccessKeyId = response.data.data.body.accessid
                    _self.dataObj.key = response.data.data.body.dir + Date.now().toString(18) + '-' + '${filename}'
                    _self.dataObj.dir = response.data.data.body.dir
                    _self.dataObj.host = response.data.data.body.host
                    _self.dataObj.bucket = response.data.data.body.bucket
                    this.$nextTick(() => resolve());
                }).catch(err => {
                    console.log("catch")
                })
            })
        },
        beforeUpload(file) {
        },
        handleUploadSuccess(res, file) {
            this.showFileList = true
            var a = this.dataObj.key.replace('${filename}', file.name)
            var fieldName = a.substring(a.indexOf('-') + 1)
            let field = { name: fieldName, url: this.dataObj.host + '/' + this.dataObj.key.replace('${filename}', file.name), size: file.size, objectKey: this.dataObj.key.replace('${filename}', file.name), caseId: this.caseId, bucket: this.dataObj.bucket }
            this.emitInput(field)
        }

    }
}
</script>